import React, { Component } from "react";

function App(props) {
    const { data, i18n } = props;

    const dealWithNum = (num) => num + "px";

    return (
        <div className="report-table">
            {/* <div className="report-table-title">摘要特征分数</div> */}
            <div className="report-table-tr">
                <div className="report-table-td">
                    <div className="report-table-td-title">{data.honesty}</div>
                    <div className="report-table-td-subtitle">{i18n.report.honesty}</div>
                </div>
                <div className="report-table-td">
                    <div className="report-table-td-circle bgColor9" style={{
                        width: dealWithNum(data.honesty),
                        height: dealWithNum(data.honesty)
                    }}></div>
                </div>
                <div className="report-table-td">
                    <p className="report-text">{i18n.report.honestyInfo1}</p>
                    <p className="report-text">{i18n.report.honestyInfo2}</p>
                </div>
            </div>
            <div className="report-table-tr">
                <div className="report-table-td">
                    <div className="report-table-td-title">{data.confidence}</div>
                    <div className="report-table-td-subtitle">{i18n.report.confidence}</div>
                </div>
                <div className="report-table-td">
                    <div className="report-table-td-circle bgColor10" style={{
                        width: dealWithNum(data.confidence),
                        height: dealWithNum(data.confidence)
                    }}></div>
                </div>
                <div className="report-table-td">
                    <p className="report-text">{i18n.report.confidenceInfo1}</p>
                    <p className="report-text">{i18n.report.confidenceInfo2}</p>
                </div>
            </div>
            <div className="report-table-tr">
                <div className="report-table-td">
                    <div className="report-table-td-title">{data.curiosity}</div>
                    <div className="report-table-td-subtitle">{i18n.report.curiosity}</div>
                </div>
                <div className="report-table-td">
                    <div className="report-table-td-circle bgColor11" style={{
                        width: dealWithNum(data.curiosity),
                        height: dealWithNum(data.curiosity)
                    }}></div>
                </div>
                <div className="report-table-td">
                    <p className="report-text">{i18n.report.curiosityInfo1}</p>
                    <p className="report-text">{i18n.report.curiosityInfo2}</p>
                </div>
            </div>
            <div className="report-table-tr">
                <div className="report-table-td">
                    <div className="report-table-td-title">{data.passion}</div>
                    <div className="report-table-td-subtitle">{i18n.report.passion}</div>
                </div>
                <div className="report-table-td">
                    <div className="report-table-td-circle bgColor12" style={{
                        width: dealWithNum(data.passion),
                        height: dealWithNum(data.passion)
                    }}></div>
                </div>
                <div className="report-table-td">
                    <p className="report-text">{i18n.report.passionInfo1}</p>
                    <p className="report-text">{i18n.report.passionInfo2}</p>
                </div>
            </div>
            <div className="report-table-tr">
                <div className="report-table-td">
                    <div className="report-table-td-title">{data.nervousness}</div>
                    <div className="report-table-td-subtitle">{i18n.report.nervousness}</div>
                </div>
                <div className="report-table-td">
                    <div className="report-table-td-circle bgColor13" style={{
                        width: dealWithNum(data.nervousness),
                        height: dealWithNum(data.nervousness)
                    }}></div>
                </div>
                <div className="report-table-td">
                    <p className="report-text">{i18n.report.nervousnessInfo1}</p>
                    <p className="report-text">{i18n.report.nervousnessInfo2}</p>
                </div>
            </div>
        </div>
    );
}

export default App;
